import React from 'react';
import './ClientsSection.css';
import { Link } from 'react-router-dom';

// Import logos (example: logo1.svg, logo2.svg, etc.)

// ... up to logo21

const logos = [
 "/logos/logo1.png",
  "/logos/logo2.png",
  "/logos/logo3.png",
  "/logos/logo4.png",
  "/logos/logo5.png",
  "/logos/logo6.png", // continue until logo21
];

const ClientsSection = () => {
  return (
    <section className="clients-section">
      <div className="container">
      <h2> Some Of Our Clients</h2>

      <div className="logo-grid">
        {logos.map((logo, index) => (
          <img src={logo} alt={`Client ${index + 1}`} key={index} className="client-logo" />
        ))}
      </div>

      <Link to="/industries">
  <button className="industries-btn">SEE ALL INDUSTRIES</button>
</Link>

      </div>
    </section>
  );
};

export default ClientsSection;
